import React, {useRef} from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './cij.css';
import './zartecbutton.css';
import img2 from '../Components/Images/CIJ/i9std.png';
import img3 from '../Components/Images/CIJ/i9micro.png';
import img4 from '../Components/Images/CIJ/i9hrs.png';
import img5 from '../Components/Images/CIJ/LT910.png';
import img6 from '../Components/Images/CIJ/LT900.png';
import img7 from '../Components/Images/CIJ/LT980.png';
import img8 from '../Components/Images/CIJ/LT880.png';
import img9 from '../Components/Images/CIJ/LT810.png';
import img10 from '../Components/Images/CIJ/LT800pro.png';
import img11 from '../Components/Images/CIJ/LT860.png';
import Cijtest from './Cijtest';

function CIJ() {
  
  const explanationRef = useRef(null); 

  const handleScroll = () => {
    if (explanationRef.current) {
      explanationRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  const productsI9 = [
    {
      id: 1,
      category: "Expiry Date Printing Machine",
      model: "i9 Std High Speed CIJ Printer",
      description: "Compact batch coding machine with IP65 protection, perfect for printing expiry dates, batch codes, and multiline information on food packaging in Dubai.",
      image: img2,
      productlink: "/I9std",
      keywords: ["expiry date printer Dubai", "high speed cij", "batch coding machine"]
    },
    {
      id: 2,
      category: "Multiline Printing System",
      model: "Tech i9 Micro CIJ Printer",
      description: "Advanced multiline printing system for Dubai industries, offering stable ink system and user-friendly interface for printing product information, dates, and barcodes.",
      image: img3,
      productlink: "/I9micro",
      keywords: ["multiline printer Dubai", "cij coding machine", "product date coding"]
    },
    {
      id: 3,
      category: "High-Speed Batch Coding Machine",
      model: "i9HRS Ultra High Speed CIJ Printer",
      description: "Ultra-fast batch coding solution for Dubai production lines, featuring twin-valve technology for printing expiry dates and serial numbers at high speeds.",
      image: img4,
      productlink: "/I9hrs",
      keywords: ["high speed batch coder", "expiry date marking machine", "Dubai industrial printer"]
    }
  ];

  const productsLT900 = [
    {
      id: 1,
      category: "Industrial Date Coding Machine",
      model: "LT910 High Speed CIJ Printer",
      description: "Reliable date coding machine for Dubai factories, offering flexible protection options for printing on various packaging materials in harsh environments.",
      image: img5,
      productlink: "/LT910",
      keywords: ["date coding machine Dubai", "industrial cij printer", "packaging printer"]
    },
    {
      id: 2,
      category: "Production Line Marking System",
      model: "LT900 High Speed CIJ Printer",
      description: "Durable marking system for Dubai production lines, capable of printing batch numbers, expiry dates, and QR codes on diverse products.",
      image: img6,
      productlink: "/LT900",
      keywords: ["production line printer", "marking system Dubai", "cij for manufacturing"]
    },
    {
      id: 3,
      category: "Ultra-Fast Expiry Date Printer",
      model: "LT980HRS Ultra High Speed CIJ Printer",
      description: "Premium high-speed expiry date printing solution for Dubai's food and pharmaceutical industries, handling maximum throughput requirements.",
      image: img7,
      productlink: "/LT980",
      keywords: ["ultra fast expiry printer", "pharmaceutical coding machine", "Dubai high speed coder"]
    }
  ];

  const productsLT800 = [
    {
      id: 1,
      category: "High-Speed Production Printer",
      model: "LT880 HRS Ultra High Speed",
      description: "Heavy-duty coding machine for Dubai's high-speed production lines, ideal for printing batch codes and expiry dates on bottles, cans, and packages.",
      image: img8,
      productlink: "/LT880",
      keywords: ["high speed production printer", "can coding machine", "Dubai industrial coding"]
    },
    {
      id: 2,
      category: "Basic Batch Coding System",
      model: "LT800/LT810 Std CIJ",
      description: "Cost-effective batch coding solution for Dubai SMEs, perfect for printing basic product information, dates, and simple codes across various industries.",
      image: img9,
      productlink: "/LT800",
      keywords: ["basic batch coder Dubai", "small business coding machine", "entry level cij"]
    },
    {
      id: 3,
      category: "Versatile Multiline Printer",
      model: "LT800 Pro/LT810 Pro High Speed CIJ",
      description: "Flexible multiline printing system for Dubai businesses, capable of handling medium to high-speed production with various ink options.",
      image: img10,
      productlink: "/LT810pro",
      keywords: ["versatile multiline printer", "pro cij Dubai", "medium speed coder"]
    },
    {
      id: 4,
      category: "Non-Porous Surface Printer",
      model: "LT860 Pigment CIJ Printer",
      description: "Specialized coding machine for Dubai's packaging industry, designed to print on challenging surfaces like plastic films and metal cans.",
      image: img11,
      productlink: "/LT880",
      keywords: ["non-porous surface printer", "plastic film coder", "metal can coding Dubai"]
    }
  ];

  return (
    <div>
      <Helmet>
        <title>CIJ Printers in Dubai | Expiry Date & Batch Coding Machines</title>
        <meta name="description" content="Premium CIJ printers in Dubai for expiry date printing, batch coding, and multiline marking systems. Find the perfect coding solution for your production line." />
        <meta name="keywords" content="CIJ printer Dubai, expiry date printing machine, batch coding system, multiline printer, industrial marking system, production line coding, Dubai coding machines" />
        <meta property="og:title" content="CIJ Printers in Dubai | Industrial Coding Solutions" />
        <meta property="og:description" content="High-quality CIJ printers for all your product coding needs in Dubai - expiry dates, batch codes, and more." />
        <link rel="canonical" href="https://www.yourwebsite.com/cij-printers" />
      </Helmet>

      <section>
        <Cijtest onScrollToExplanation={handleScroll} />
      </section>

      <section className='sect1' ref={explanationRef}>
        <Container className="py-5">
          <h1 className="mb-4 cijh2" style={{fontSize:"30px"}}>I9 Series CIJ Printers - Expiry Date & Batch Coding Machines</h1>
          <p className="lead mb-4">Our I9 series of continuous inkjet printers in Dubai are perfect for printing expiry dates, batch codes, and product information on various packaging materials. These reliable coding machines are designed for Dubai's industrial environment.</p>
          <Row>
            {productsI9.map(product => (
              <Col lg={4} md={6} className="mb-4" key={product.id}>
                <Card className="h-100 border-light shadow-sm rounded-3">
                  <Card.Body className="d-flex flex-column">
                    <span className="mb-2" 
                      style={{
                        background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        color: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        textDecoration: "none",
                        marginTop: "auto",
                      }}>
                      {product.category}
                    </span>
                    <h2 className="mb-3 cijh2 fw-bold" style={{fontSize:"16px"}}>{product.model}</h2>
                    <p className="text-muted">{product.description}</p>
                    <Link to={product.productlink}>
                      <button className={`zartec-btn zartec-btn-primary zartec-btn-small`}>
                        View Product Details
                      </button>
                    </Link>
                  </Card.Body>
                  <div className="p-3 text-center">
                    <img 
                      src={product.image} 
                      alt={`${product.model} - ${product.category} in Dubai`} 
                      className="img-fluid" 
                      style={{ maxHeight: '200px' }} 
                      loading="lazy"
                    />
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section>
        <Container className="py-5">
          <h1 className="mb-4 cijh2" style={{fontSize:"30px"}}>LT900 Series - Industrial Marking Systems for Dubai</h1>
          <p className="lead mb-4">The LT900 series of industrial CIJ printers in Dubai are built for demanding production environments, offering reliable date coding and product marking solutions for various industries.</p>
          <Row>
            {productsLT900.map(product => (
              <Col lg={4} md={6} className="mb-4" key={product.id}>
                <Card className="h-100 border-light shadow-sm rounded-3">
                  <Card.Body className="d-flex flex-column">
                    <span className="mb-2"
                      style={{
                        background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        color: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        textDecoration: "none",
                        marginTop: "auto",
                      }}>
                      {product.category}
                    </span>
                    <h2 className="mb-3 cijh2 fw-bold" style={{fontSize:"16px"}}>{product.model}</h2>
                    <p className="text-muted">{product.description}</p>
                    <Link to={product.productlink}>
                      <button className={`zartec-btn zartec-btn-primary zartec-btn-small`}>
                        View Product Details
                      </button>
                    </Link>
                  </Card.Body>
                  <div className="p-3 text-center">
                    <img 
                      src={product.image} 
                      alt={`${product.model} - ${product.category} for Dubai industries`} 
                      className="img-fluid" 
                      style={{ maxHeight: '200px' }} 
                      loading="lazy"
                    />
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section>
        <Container className="py-5">
          <h1 className="mb-4 cijh2" style={{fontSize:"30px"}}>LT800 Series - Versatile Coding Machines in Dubai</h1>
          <p className="lead mb-4">From basic batch coding to specialized printing on challenging surfaces, our LT800 series offers flexible coding solutions for Dubai businesses of all sizes.</p>
          <Row>
            {productsLT800.map(product => (
              <Col lg={4} md={6} className="mb-4" key={product.id}>
                <Card className="h-100 border-light shadow-sm rounded-3">
                  <Card.Body className="d-flex flex-column">
                    <span className="mb-2"
                      style={{
                        background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        color: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        textDecoration: "none",
                        marginTop: "auto",
                      }}>
                      {product.category}
                    </span>
                    <h2 className="mb-3 cijh2 fw-bold" style={{fontSize:"16px"}}>{product.model}</h2>
                    <p className="text-muted">{product.description}</p>
                    <Link to={product.productlink} onClick={() => window.scrollTo(0, 0)}>
                      <button className={`zartec-btn zartec-btn-primary zartec-btn-small`}>
                        View Product Details
                      </button>
                    </Link>
                  </Card.Body>
                  <div className="p-3 text-center">
                    <img 
                      src={product.image} 
                      alt={`${product.model} - ${product.category} available in Dubai`} 
                      className="img-fluid" 
                      style={{ maxHeight: '200px' }} 
                      loading="lazy"
                    />
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default CIJ;